var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "PanelMenu" }, [
    _c("div", { staticClass: "ui inverted two item top fixed menu" }, [
      _c(
        "a",
        {
          staticClass: "item",
          class: { active: _vm.config.session.displayPanel === "text" },
          on: {
            click: function($event) {
              _vm.config.session.displayPanel = "text"
            }
          }
        },
        [
          _c("i", { staticClass: "file alternate icon" }),
          _vm._v("\n      Text\n    ")
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "item",
          class: {
            active: _vm.config.session.displayPanel === "configuration"
          },
          on: {
            click: function($event) {
              _vm.config.session.displayPanel = "configuration"
            }
          }
        },
        [
          _c("i", { staticClass: "cogs icon" }),
          _vm._v("\n      Configuration\n    ")
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "menu-padding" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }